// #region Tapecase
const activeClass = 'roc-pdp-sections__section--active';
/**
 * Perform module setup for product details page tabs
 */
export default function setupAccordian() {
	const buttons = document.querySelectorAll('.roc-accordion__pdp .roc-accordion__pdp-trigger');

	buttons.forEach((btn) => {
		btn.addEventListener('click', () => {
			if (btn.parentElement?.parentElement?.classList.contains(activeClass)) {
				btn.parentElement?.parentElement?.classList.remove(activeClass);
				btn.setAttribute('aria-expanded', 'false');
			} else {
				btn.parentElement?.parentElement?.classList.add(activeClass);
				btn.setAttribute('aria-expanded', 'true');
			}
		});
	});
}
// #endregion
